import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { displayValue, formatDateTime } from '../utils';

const Settings = {
  Name: 'Stats',
  Display: true,
  options: {
    view: null,
    settings: [
      { id: 'emptyText', type: 'text', name: 'Empty text', default: 'Unknown' },
    ],
    grid: true,
  },
};

const Row = ({ label, value }) => (
  <Typography variant="body2">
    <Typography component="strong" sx={{ fontWeight: 700 }}>{label}: </Typography>
    <Typography component="span">{value}</Typography>
  </Typography>
);

const View = ({ DevicesDetails = {}, Settings: userSettings = {} }) => {
  const emptyText = userSettings.emptyText || 'Unknown';

  return (
    <Box>
      <Stack spacing={0.5}>
        <Row label="Name" value={displayValue(DevicesDetails.name, emptyText)} />
        <Row label="ID" value={displayValue(DevicesDetails.DeviceId ?? DevicesDetails.id, emptyText)} />
        <Row label="# Entries" value={displayValue(DevicesDetails.entries, emptyText)} />
        <Row label="Created" value={formatDateTime(DevicesDetails.dateCreated, emptyText)} />
        <Row label="Last entry" value={formatDateTime(DevicesDetails.dateLastEntries ?? DevicesDetails.dateLastEntry, emptyText)} />
        <Row label="Updated" value={formatDateTime(DevicesDetails.dateUpdated, emptyText)} />
      </Stack>
    </Box>
  );
};

export default {
  Settings,
  View,
};
